module.exports = __webpack_public_path__ + "img/board_title-in.1da773b1.png";